// extracted by mini-css-extract-plugin
export default {"row_actions":"AdminsTable_row_actions__LR7p5"};